import { Container, Section, Stack } from "@humaniti/ui";
import { type ReactNode } from "react";

export interface LegalSection {
  id: string;
  title: string;
  body: ReactNode;
}

export interface LegalPageProps {
  title: string;
  effectiveDate: string;
  intro?: ReactNode;
  sections: LegalSection[];
}

export const LegalPage = ({ title, effectiveDate, intro, sections }: LegalPageProps) => (
  <Section>
    <Container size="default">
      <Stack gap="xl">
        <header>
          <h1
            style={{
              margin: 0,
              fontFamily: "var(--font-sans)",
              fontWeight: 500,
              fontSize: "var(--fs-h1)",
              lineHeight: "var(--lh-h1)",
              letterSpacing: "-0.01em",
            }}
          >
            {title}
          </h1>
          <p
            style={{
              margin: "var(--space-2) 0 0",
              fontFamily: "var(--font-mono)",
              fontSize: "var(--fs-label)",
              letterSpacing: "0.06em",
              textTransform: "uppercase",
              color: "var(--fg-secondary)",
            }}
          >
            Effective {effectiveDate}
          </p>
        </header>

        {intro && (
          <div
            style={{
              fontSize: "var(--fs-body-lg)",
              lineHeight: "var(--lh-body-lg)",
              color: "var(--fg-primary)",
            }}
          >
            {intro}
          </div>
        )}

        <nav>
          <span
            style={{
              fontFamily: "var(--font-mono)",
              fontSize: "var(--fs-label)",
              letterSpacing: "0.08em",
              textTransform: "uppercase",
              color: "var(--fg-secondary)",
            }}
          >
            Contents
          </span>
          {/* Section titles already include numbering ("1. What we collect"); use
              an unstyled list so the browser doesn't add a second "1." marker. */}
          <ul style={{ listStyle: "none", margin: "var(--space-3) 0 0", padding: 0 }}>
            {sections.map((s) => (
              <li key={s.id} style={{ padding: "var(--space-1) 0" }}>
                <a href={`#${s.id}`} style={{ color: "var(--fg-primary)" }}>
                  {s.title}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <Stack gap="2xl">
          {sections.map((s) => (
            <section key={s.id} id={s.id}>
              <h2
                style={{
                  margin: 0,
                  fontFamily: "var(--font-sans)",
                  fontWeight: 500,
                  fontSize: "var(--fs-h2)",
                  lineHeight: "var(--lh-h2)",
                }}
              >
                {s.title}
              </h2>
              <div
                style={{
                  marginTop: "var(--space-4)",
                  fontSize: "var(--fs-body)",
                  lineHeight: "var(--lh-body)",
                }}
              >
                {s.body}
              </div>
            </section>
          ))}
        </Stack>
      </Stack>
    </Container>
  </Section>
);
